<mat-dialog-content>
    @if (sanitizedUrlToOpen()) {
        <iframe [src]="sanitizedUrlToOpen()" class="iframe" #embedded></iframe>
    }
    @if (!isReady()) {
        <div class="waiting-panel">
            <mat-spinner></mat-spinner>
        </div>
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button class="btn-themed" [disabled]="!canSave()" (click)="save()">{{ "Save" | translate }}</button>
    <button mat-button class="btn-themed" mat-dialog-close>{{ "Close" | translate }}</button>
</mat-dialog-actions>
